import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Navegação */}
        <div className="mb-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-primary-600 hover:text-primary-500 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao início
          </Link>
        </div>

        {/* Cabeçalho */}
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-secondary-900 mb-4 font-display">
            Termos de Uso
          </h1>
          <p className="text-lg text-secondary-600">
            Última atualização: 16 de setembro de 2024
          </p>
        </div>

        {/* Conteúdo */}
        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">1. Aceitação dos Termos</h2>
            <p className="text-secondary-700 mb-4">
              Ao acessar e usar a plataforma BIZREP, você concorda em cumprir e estar vinculado a estes 
              Termos de Uso. Se você não concordar com qualquer parte destes termos, não deve usar nossos serviços.
            </p>
            <p className="text-secondary-700">
              Estes termos se aplicam a todos os visitantes, usuários e outras pessoas que acessam ou usam o serviço.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">2. Descrição do Serviço</h2>
            <p className="text-secondary-700 mb-4">
              O BIZREP é uma plataforma de automação de negócios que oferece:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Assistentes de IA personalizados para atendimento ao cliente</li>
              <li>Integração com canais de comunicação (WhatsApp, Instagram, Facebook)</li>
              <li>Gestão automatizada de campanhas de marketing digital</li>
              <li>Análise e relatórios de performance</li>
              <li>Sincronização de catálogo de produtos</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">3. Conta de Usuário</h2>
            <p className="text-secondary-700 mb-4">
              Para usar nossos serviços, você deve criar uma conta fornecendo informações precisas e completas. 
              Você é responsável por:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Manter a confidencialidade de sua senha</li>
              <li>Todas as atividades que ocorrem em sua conta</li>
              <li>Notificar-nos imediatamente sobre qualquer uso não autorizado</li>
              <li>Manter suas informações de conta atualizadas</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">4. Uso Aceitável</h2>
            <p className="text-secondary-700 mb-4">
              Você concorda em usar nossos serviços apenas para fins legais e de acordo com estes termos. 
              É proibido:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Usar o serviço para qualquer propósito ilegal ou não autorizado</li>
              <li>Transmitir vírus, malware ou qualquer código malicioso</li>
              <li>Interferir ou interromper os serviços ou servidores</li>
              <li>Tentar acessar contas de outros usuários</li>
              <li>Usar o serviço para spam ou comunicações não solicitadas</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">5. Propriedade Intelectual</h2>
            <p className="text-secondary-700 mb-4">
              O BIZREP e seus conteúdos originais, recursos e funcionalidades são e permanecerão propriedade 
              exclusiva da M42Orion Tecnologia Ltda. e seus licenciadores.
            </p>
            <p className="text-secondary-700">
              O serviço é protegido por direitos autorais, marcas registradas e outras leis. 
              Nossos nomes comerciais e marcas não podem ser usados sem nossa permissão prévia por escrito.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">6. Privacidade e Dados</h2>
            <p className="text-secondary-700 mb-4">
              Sua privacidade é importante para nós. Nossa coleta e uso de informações pessoais é regida 
              por nossa Política de Privacidade, que está incorporada a estes termos por referência.
            </p>
            <p className="text-secondary-700">
              Ao usar nossos serviços, você concorda com a coleta e uso de informações de acordo com 
              nossa Política de Privacidade.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">7. Pagamentos e Assinaturas</h2>
            <p className="text-secondary-700 mb-4">
              Alguns de nossos serviços são oferecidos mediante pagamento. Os termos de pagamento incluem:
            </p>
            <ul className="list-disc list-inside text-secondary-700 mb-4 space-y-2">
              <li>Pagamentos são processados através de provedores terceirizados seguros</li>
              <li>Assinaturas são renovadas automaticamente, salvo cancelamento</li>
              <li>Reembolsos são processados de acordo com nossa política de reembolso</li>
              <li>Preços podem ser alterados com aviso prévio de 30 dias</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">8. Limitação de Responsabilidade</h2>
            <p className="text-secondary-700 mb-4">
              Em nenhuma circunstância a M42Orion, seus diretores, funcionários, parceiros, agentes, 
              fornecedores ou afiliados serão responsáveis por quaisquer danos indiretos, incidentais, 
              especiais, consequenciais ou punitivos.
            </p>
            <p className="text-secondary-700">
              Isso inclui, sem limitação, perda de lucros, dados, uso, boa vontade ou outras perdas 
              intangíveis resultantes do uso ou incapacidade de usar o serviço.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">9. Rescisão</h2>
            <p className="text-secondary-700 mb-4">
              Podemos encerrar ou suspender sua conta imediatamente, sem aviso prévio ou responsabilidade, 
              por qualquer motivo, incluindo, sem limitação, se você violar os Termos de Uso.
            </p>
            <p className="text-secondary-700">
              Após a rescisão, seu direito de usar o serviço cessará imediatamente. Se você deseja 
              encerrar sua conta, pode simplesmente parar de usar o serviço.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">10. Alterações nos Termos</h2>
            <p className="text-secondary-700 mb-4">
              Reservamos o direito, a nosso exclusivo critério, de modificar ou substituir estes Termos 
              a qualquer momento. Se uma revisão for material, tentaremos fornecer pelo menos 30 dias 
              de aviso antes de quaisquer novos termos entrarem em vigor.
            </p>
            <p className="text-secondary-700">
              O que constitui uma mudança material será determinado a nosso exclusivo critério.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">11. Lei Aplicável</h2>
            <p className="text-secondary-700 mb-4">
              Estes Termos serão interpretados e regidos de acordo com as leis do Brasil, 
              sem consideração aos seus conflitos de disposições legais.
            </p>
            <p className="text-secondary-700">
              Nossa falha em fazer cumprir qualquer direito ou disposição destes Termos não será 
              considerada uma renúncia a esses direitos.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-secondary-900 mb-4">12. Contato</h2>
            <p className="text-secondary-700 mb-4">
              Se você tiver alguma dúvida sobre estes Termos de Uso, entre em contato conosco:
            </p>
            <div className="bg-secondary-50 p-4 rounded-lg">
              <p className="text-secondary-700 mb-2">
                <strong>M42Orion Tecnologia Ltda.</strong>
              </p>
              <p className="text-secondary-700 mb-2">
                E-mail: contato@m42orion.com
              </p>
              <p className="text-secondary-700 mb-2">
                Telefone: (11) 9999-9999
              </p>
              <p className="text-secondary-700">
                Endereço: Rua das Tecnologias, 123 - São Paulo, SP
              </p>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsPage;

